import script from "./customFieldViewColumnInput.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldViewColumnInput.vue?vue&type=script&setup=true&lang=js"

import "./customFieldViewColumnInput.vue?vue&type=style&index=0&id=0774d1fe&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0774d1fe"]])

export default __exports__